/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CountUserNotificationsResponse {
    getFixupPrototypeFunction() { return CountUserNotificationsResponse.fixupPrototype; }

    static newInstance(model: Partial<CountUserNotificationsResponse>): CountUserNotificationsResponse {
        let obj = Object.assign(new CountUserNotificationsResponse(), model);
        CountUserNotificationsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CountUserNotificationsResponse>): CountUserNotificationsResponse {
        if (!model) return null;
        return CountUserNotificationsResponse.newInstance(<CountUserNotificationsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CountUserNotificationsResponse) {
        if (!obj) return;

        models.CountUserNotificationsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CountUserNotificationsResponse): boolean {
        Object.setPrototypeOf(obj, CountUserNotificationsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.notifications === undefined) {
            this.notifications = 0;
        }
        if (this.messages === undefined) {
            this.messages = 0;
        }
    }

    /**
     * Number of notifications
     */
    notifications: number;

    /**
     * Number of messages
     */
    messages: number;

}
